// extracted by mini-css-extract-plugin
export default {"outer":"TF","outernoline":"UF","heading":"VF","text":"WF","inner":"XF"};
    if(module.hot) {
      // 1715188236481
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  